// src/uuid.ts
function randomUUID() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === "x" ? r : r & 3 | 8;
    return v.toString(16);
  });
}
function randomString(length) {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

// src/time.ts
var TimeService = class {
  constructor() {
    this.cache = null;
    this.CACHE_DURATION = 3e4;
    // 30 seconds cache
    this.TIME_API_URL = "https://time.phantom.app/utc";
  }
  static getInstance() {
    if (!TimeService.instance) {
      TimeService.instance = new TimeService();
    }
    return TimeService.instance;
  }
  /**
   * Get current timestamp from Phantom's secure time API
   * Includes basic caching to reduce API calls
   */
  async now() {
    const now = Date.now();
    if (this.cache && now - this.cache.fetchedAt < this.CACHE_DURATION) {
      const elapsed = now - this.cache.fetchedAt;
      return this.cache.timestamp + elapsed;
    }
    try {
      const response = await fetch(this.TIME_API_URL);
      if (!response.ok) {
        throw new Error(`Time API responded with status: ${response.status}`);
      }
      const timestampText = await response.text();
      const timestamp = parseInt(timestampText, 10);
      if (isNaN(timestamp)) {
        throw new Error(`Invalid timestamp received: ${timestampText}`);
      }
      this.cache = {
        timestamp,
        fetchedAt: now
      };
      return timestamp;
    } catch (error) {
      return Date.now();
    }
  }
  /**
   * Synchronous version that uses cached time if available,
   * otherwise falls back to Date.now()
   */
  nowSync() {
    if (this.cache) {
      const elapsed = Date.now() - this.cache.fetchedAt;
      if (elapsed < this.CACHE_DURATION) {
        return this.cache.timestamp + elapsed;
      }
    }
    return Date.now();
  }
  /**
   * Clear the cache (useful for testing)
   */
  clearCache() {
    this.cache = null;
  }
};
var timeService = TimeService.getInstance();
var getSecureTimestamp = () => timeService.now();
var getSecureTimestampSync = () => timeService.nowSync();

// src/network.ts
function getChainPrefix(networkId) {
  return networkId.split(":")[0].toLowerCase();
}
function isEthereumChain(networkId) {
  const network = getChainPrefix(networkId);
  return network === "eip155";
}
function isSolanaChain(networkId) {
  const network = getChainPrefix(networkId);
  return network === "solana";
}
export {
  getChainPrefix,
  getSecureTimestamp,
  getSecureTimestampSync,
  isEthereumChain,
  isSolanaChain,
  randomString,
  randomUUID
};
